export const ENRICH_CELERMINE_JUICE = 'ENRICH_CELERMINE_JUICE';
export const SPARKLING_CANDY = 'SPARKLING_CANDY';

export const additionalEquipModTable = {
  [ENRICH_CELERMINE_JUICE]: 10,
  [SPARKLING_CANDY]: 25,
};
